<template>
    <div
        v-if="!isDismissed"
        :class="componentClass"
        class="px-3 py-6 md:py-3 mx-6 md:mx-0 mb-6 border rounded transition-colors duration-150"
    >
        <level>
            <div class="flex flex-col md:flex-row items-center">
                <icon v-if="icon" :path="icon" w="w-10 md:w-5" h="h-10 md:h-5" size="24" class="md:mr-2"/>
                <span class="text-center md:text-left"><slot/></span>
            </div>
            <slot v-if="hasRightSlot" name="right"/>
            <jb-button v-else-if="canDismiss" :icon="mdiClose" @click="dismiss" small/>
        </level>
    </div>
</template>

<script>
import {ref, computed} from 'vue'
import {mdiClose} from '@mdi/js'
import {colorsBg, colorsOutline} from '@/colors.js'
import Level from '@/Components/Dashboard/Level'
import Icon from '@/Components/Dashboard/Icon'
import JbButton from '@/Components/Dashboard/JbButton'

export default {
    name: 'Notification',
    components: {
        Icon,
        Level,
        JbButton
    },
    props: {
        icon: String,
        outline: Boolean,
        canDismiss: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            required: true
        }
    },
    setup(props, {slots}) {
        const componentClass = computed(() => props.outline ? colorsOutline[props.color] : colorsBg[props.color])

        const isDismissed = ref(false)

        const dismiss = () => {
            isDismissed.value = true
        }

        const hasRightSlot = computed(() => slots.right)

        return {
            componentClass,
            isDismissed,
            dismiss,
            hasRightSlot,
            mdiClose
        }
    }
}
</script>
